import {
    BooleanField,
    Datagrid,
    DateField,
    DateInput, FunctionField, Link,
    ListProps,
    NullableBooleanInput,
    ReferenceField,
    SelectInput,
    TextField,
    TextInput
} from "react-admin";
import {CustomList} from "../../components/CustomList";
import {useOptionsResource} from "../../shared/hooks/useOptionsResource";
import {getDefaultListProps, initField} from "../../shared/utils";
import {ReferenceInputSubject} from "../../components/reference-inputs/ReferenceInputSubject";
import {useOptions} from "../../shared/hooks/useOptions";
import {DownloadCarrierCashBoxPdfButton} from "./DownloadCarrierCashBoxPdfButton";
import {getUser, hasPermission} from "../../authProvider";
import {ComplededBulkButton} from "./ComplededBulkButton";
import {NotComplededBulkButton} from "./NotComplededBulkButton";
import {CarrierCashBoxHeader} from "./CarrierCashBoxHeader";


const rowStyle = (record: any, index: any) => ({
  minHeight: "40px",
  height: "40px",
});

export const CarrierCashBoxList = (props: ListProps) => {
  const { data: options } = useOptionsResource("GET");
  const { data: optionsCarrierCashBox } = useOptions("carrier_cashboxes", "GET");

  const filters = options && optionsCarrierCashBox
    ? [
      <TextInput {...initField("id", options)} />,

      <DateInput
        {...initField("date_after", options)}
        label="Data dal"
      />,
      <DateInput
        {...initField("date_before", options)}
        label="Data fino al"
      />,
      <SelectInput
        {...initField("type", options, "array")}
        choices={optionsCarrierCashBox.type.choices}
        label="Tipo"
      />,
      <NullableBooleanInput
        {...initField("printed", options)}
        label="Stampata"
      />,
      <NullableBooleanInput
        {...initField("completed", options)}
        label="Completata"
        alwaysOn
      />,

    ]
    : [];

  if (options &&
    props &&
    props.permissions &&
    props.permissions.includes('registry.view_subject')) {
    filters.push(
      <ReferenceInputSubject
        {...initField("carrier", options)}
        filter={{ type: "carrier" }}
        label="Vettore"
        alwaysOn
      />
    )
  }
  const user = getUser();

  return options && optionsCarrierCashBox ? (
    <CustomList
      sort={{ field: "id", order: "DESC" }}
      filters={filters}
      shouldExport={false}
      filterDefaultValues={{
          completed: false
      }}
      {...getDefaultListProps(props)}
      topElement={<CarrierCashBoxHeader />}
      bulkActionButtons={hasPermission(props.permissions, "base.change_carriercashbox_status") ? <><ComplededBulkButton /><NotComplededBulkButton /></> : false}
    >
      <Datagrid rowStyle={rowStyle}>

        <TextField {...initField("id", options)} />

          {!user.is_carrier && <FunctionField render={(record: any) => <Link to={`cachets?displayedFilters={"carrier_cash_box"%3Atrue}&filter={"carrier_cash_box"%3A${record.id}}`}>Vai</Link>} label={"Contrassegno"} />}

        {
          props.permissions && props.permissions.includes('registry.view_subject') ?
            <ReferenceField
              {...initField("carrier", options)}
              label="Vettore"
              reference="subjects"
            >
              <TextField source="business_name" />
            </ReferenceField>
            : null
        }
        <DownloadCarrierCashBoxPdfButton />
        <DateField source="date" options={options} label={"Data"} />
        <TextField {...initField("type", options)} label={"Tipo"} />
        <TextField {...initField("total", options)} label={"Totale"} />
        <TextField {...initField("cash", options)} label={"Totale contanti"} />
        <TextField {...initField("check", options)} label={"Totale assegni"} />
        <DateField {...initField("print_date", options)} label={"Stampata"} showTime />
        <BooleanField {...initField("completed", options)} label={"Completata"} />
      </Datagrid>
    </CustomList>
  ) : null;
};
